import { render, staticRenderFns } from "./BvIndex.vue?vue&type=template&id=5b6d1fa2&"
import script from "./BvIndex.vue?vue&type=script&lang=ts&"
export * from "./BvIndex.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports